import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';
import { features } from '@/content/features';
import { Reveal } from '@/components/Reveal';

export function Features(): JSX.Element {
  return (
    <section id="platform" className="py-16 md:py-24">
      <div className="container-content">
        <Reveal>
          <div className="mx-auto mb-14 max-w-xl text-center">
            <span className="text-xs font-bold uppercase tracking-[0.14em] text-nexus-purple-light">
              One platform
            </span>
            <h2 className="mt-3 font-display text-3xl font-bold text-nexus-ink md:text-[36px]">
              Everything managed IT touches.
            </h2>
            <p className="mt-4 text-white/70">
              Every module on one multi-tenant platform — built for how MSPs and the
              organizations they serve actually budget, staff, and get audited.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <Reveal key={f.slug} delay={(i % 3) * 80}>
                <Link
                  to={`/platform/${f.slug}`}
                  className="group flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.02] p-6 no-underline transition-all duration-200 hover:-translate-y-1 hover:border-nexus-purple/50"
                >
                  <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-nexus-purple/[0.14] text-nexus-purple-light transition-transform duration-200 group-hover:scale-110">
                    <Icon fontSize="small" />
                  </div>
                  <h3 className="font-display text-[17px] font-semibold text-nexus-ink">{f.title}</h3>
                  <p className="mt-1.5 flex-1 text-sm text-white/65">{f.body}</p>
                  {f.badge && (
                    <Chip
                      label={f.badge}
                      size="small"
                      className="mt-3.5 h-[22px] w-fit border border-nexus-purple/35 bg-transparent text-[10.5px] font-bold tracking-wide text-nexus-purple-light"
                    />
                  )}
                </Link>
              </Reveal>
            );
          })}
        </div>

        <div className="mt-10 flex justify-center">
          <Button
            component={Link}
            to="/platform"
            variant="outlined"
            endIcon={<ArrowForwardIcon />}
            className="border-white/15 normal-case"
          >
            Explore the full platform
          </Button>
        </div>
      </div>
    </section>
  );
}
